import { render, staticRenderFns } from "./world-map-1p1c.vue?vue&type=template&id=0e0385a1&scoped=true&"
import script from "./world-map-1p1c.vue?vue&type=script&lang=js&"
export * from "./world-map-1p1c.vue?vue&type=script&lang=js&"
import style0 from "./world-map-1p1c.vue?vue&type=style&index=0&id=0e0385a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0385a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VLayout,VSwitch,VToolbarTitle,VTooltip})
